/* eslint-disable */
import Swiper, { Autoplay, Navigation } from 'swiper';
Swiper.use([Navigation, Autoplay]);

export default {
  init() {
    const swiper = new Swiper('.clients__container', {
      slidesPerView: 1,
      speed: 700,
      loop: true,
      loopAdditionalSlides: 1,
      navigation: {
        nextEl: '.clients__next',
        prevEl: '.clients__prev'
      },
      autoplay: {
        delay: 2000
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          autoplay: {
            delay: 5000
          }
        }
      }
    });
  }
};
